import { render, staticRenderFns } from "./Brochures.vue?vue&type=template&id=1fd2bd0d&"
import script from "./Brochures.vue?vue&type=script&lang=js&"
export * from "./Brochures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports